import React from "react";
import { Link as Link1 } from "react-scroll";
import ProjectManagementSection from "./ProjectManagementSection";
import FundRaiseSection from "./FundRaiseSection";
import StudioSection from "./StudioSection";
import CommunitySection from "./CommunitySection";
class WeNatSolutionsSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {

        return (
            <section className='lndSolutionsWrap sectionLndAll'>
                <div className='title'>
                    <h2>WeNat Solutions</h2>
                </div>
                <div className='lndSolutionTop'>
                <p>Our digital solutions empower individuals and organizations working in Nature, Climate Action, SDGs and ESG, with
                    innovative tools to scale their efforts while enhancing efficiency, accountability, communication, and cost reduction.
                    Solutions come handy in exploring opportunities to earn livelihood and learning avenues.</p>
                <p>These solutions harness the power of technology to streamline processes, optimize resource allocation, and drive
                    positive impact on the ecosystem.Through advanced data analytics and automation, our digital solutions enable users to
                    monitor and evaluate their conservation projects in real-time.</p>
                </div>

                <div className="ladBookDemo"><span>Go live instantly. Need help in implementation?</span> <a href="https://forms.gle/GDxeCsigaVPK2Yx9A" className="btn" target="_blank">Book a Demo</a></div>

                <div className='lndSolutionNav'>
                    <Link1 to="projectMngmnt" offset={-150} spy={true} smooth={true}>
                        <figure><i className='iProjects_OL' /></figure>
                        <span>Project</span>
                    </Link1>
                    <Link1 to="fundRaise" offset={-150} spy={true} smooth={true}>
                        <figure><i className='iFund-Raise-01' /></figure>
                        <span>Fund Raise</span>
                    </Link1>
                    <Link1 to="studio" offset={-150} spy={true} smooth={true}>
                        <figure><i className='iistudio_icon' /></figure>
                        <span>Studio</span>
                    </Link1>
                    <Link1 to="community" offset={-150} spy={true} smooth={true}>
                        <figure><i className='iCircle_Ol' /></figure>
                        <span>Community</span>
                    </Link1>
                </div>                

                <ProjectManagementSection />
                <FundRaiseSection />
                <StudioSection />
                <CommunitySection />
            </section>
        );
    }
}

export default WeNatSolutionsSection;